import React,{Component} from 'react';
import _ from 'lodash'
import {FormSectionTitle, FormRow, FormColumn, Label} from './FormElements'
import provinces from 'provinces'
import countries from './countries'
import {potentialUsers, purchasingTimeFrame, potentialSalesValue, salesforceRegion, serviceInterest, salesforceSegment} from '../Picklists'
export default class Form extends Component {
    constructor(props){
    	super(props);
    	this.state = {
        firstName:'',
        lastName:'',
        title: '',
        companyName:'',
        city: '',
        country:'',
        integrations: '',
        scopingDetails: '',
        desiredStartDate: '',
        desiredGoLiveDate: '',
        state: '',
        website: '',
        email:'',
        phoneNumber:'',
        numberOfEmployees: '',
        serviceOfInterestType: 'Partner Request Form',
        potentialUsers: '',
        purchasingTimeframe: '',
        potentialSalesValue: '',
        goals:'',
        pains:'',
        nextSteps: '',
        AeFullNameSFDC: '',
        AeFullNameSFMC: '',
        AeEmailSFMC:'',
        AeEmailSFDC:'',
        existingLicences: '',
        sellingLicenses: '',
        salesforceRegion:'',
        salesforceSegment: '',
        keyFeatures: '',
        techStack:'',
        serviceInterest:[],
        errors: {},

      };

      this.handleInputChange = this.handleInputChange.bind(this)
      this.validateForm = this.validateForm.bind(this)
      this.checkboxesfromList = this.checkboxesfromList.bind(this)
      this.loadStateOptions = this.loadStateOptions.bind(this)
    }





    loadCountries(){

      return(
        _.map(countries, country => {
            return(
              <option key={country.name} name="country" value={country.name}>{country.name}</option>
            )
        })
      )
    }

    optionsFromList(list, name){
      return(
        list.map(item => {
          return(
            <option key={item} name={name} value={item}>{item}</option>
          )
        })
      )
    }

    handleCheckboxChange(event){
      const {value} = event.target
      const serviceInterestCopy = this.state.serviceInterest.slice()
      const index = serviceInterestCopy.indexOf(value)

      if(index > -1) {
        console.log(value + ' is on index ' + index)
        serviceInterestCopy.splice(index,1)
      }else{
        console.log(value +' is not in list. Adding...')
        serviceInterestCopy.push(value)
      }

      this.setState({
        serviceInterest: serviceInterestCopy
      })

    }

    checkboxesfromList(list, name){

      return(
        list.map((item, index) => {
            return(
              <FormColumn>
                <div className="w-checkbox" key={index}>
                  <input type="checkbox" id={item} name={name} value={item} onChange={this.handleCheckboxChange.bind(this)} checked={this.state.serviceInterest.indexOf(item) > -1} className="w-checkbox-input" />
                  <label for={item}>
                    {item}
                  </label>
                </div>
              </FormColumn>
            )
        })
      )
    }

    loadStateOptions(){

      let states = countries[this.state.country]['states']
      console.log(states)

      if(states.length > 0){
        return(
        <FormColumn half>
            <Label required>State / Province</Label>
            <select required value={this.state.state} name="state" onChange={this.handleInputChange} className="w-select">
              <option disabled value="" selected>Select One</option>
              {
                states.map(state => {
                  return(
                    <option name='state' value={state.name}>{state.name}</option>
                  )
                })
              }
            </select>
          </FormColumn>

        )
      }else{
        return(
             null
           )
      }


      }

    loadStates(){
      let hasSelectedCountry = this.state.country ? true : false

      if(hasSelectedCountry){
        return(


          this.loadStateOptions()

        )
      }else{
        return(

        null
        )
      }
    }



    handleSubmit = (event) =>{
      event.preventDefault()
      this.validateForm()
      console.log('form submitted', this.state)
    }

    validateForm(){
      let errors = {}

 
      if(this.state.AeEmailSFDC.indexOf('@salesforce.com') == -1 && this.state.AeEmailSFDC.length > 0 ){
        errors['AeEmailSFDC'] = 'You must enter a @salesforce.com email'
      }

      if(this.state.AeEmailSFDC.indexOf('@salesforce.com') == -1 && this.state.AeEmailSFDC.length > 0 ){
        errors['AeEmailSFDC'] = 'You must enter a @salesforce.com email'
      }

      if(this.state.email.indexOf('@salesforce.com') > 0 && this.state.email.length > 0 ){
        errors['email'] = 'You must not enter a @salesforce.com email'
      }

      this.setState({
        errors: errors
      })
    }



    handleInputChange(event){
      const target = event.target
      const name = target.name
      const value = target.value
      this.setState({
        [name]: value
      })

      if (name=='country'){
        this.setState({
          'state':''
        })
      }


    }

    render() {
        return (
          <div className="form-shadow-container w-form">
            <form id="email-form" action="https://go.pardot.com/l/80582/2018-01-09/6vkqy3" method="post">
            <FormSectionTitle>Account Executive Information</FormSectionTitle>

            <FormRow>
  <FormColumn half>
    <Label required>Marketing Cloud Account Executive Full Name</Label>
    <input type="text" onChange={this.handleInputChange} className="w-input" value={this.state.AeFullNameSFMC} name="AeFullNameSFMC" data-name="Field 4" placeholder="AE Full Name"  required="required"/>
  </FormColumn>
  <FormColumn half>
    <Label required help="must be a @salesforce.com email">Marketing Cloud Account Executive Email</Label>
    <input type="email" onChange={this.handleInputChange} onKeyUp={this.validateForm} className="w-input" value={this.state.AeEmailSFMC} name="AeEmailSFMC" data-name="Field 4" placeholder="@salesforce.com Email Address"  required="required"/>
    <span className="danger">{this.state.errors['AeEmailSFMC']}</span>
  </FormColumn>
</FormRow>


<FormRow>
  <FormColumn half>
    <Label required>Core Account Executive Full Name</Label>
    <input type="text" onChange={this.handleInputChange} className="w-input" value={this.state.AeFullNameSFDC} name="AeFullNameSFDC" data-name="Field 4" placeholder="AE Full Name"  required="required"/>
  </FormColumn>
  <FormColumn half>
    <Label required help="must be a @salesforce.com email">Core Account Executive Email </Label>
    <input type="email" onChange={this.handleInputChange} onKeyUp={this.validateForm} className="w-input" value={this.state.AeEmailSFDC} name="AeEmailSFDC" data-name="Field 4" placeholder="@salesforce.com Email Address"  required="required" />
    <span className="danger">{this.state.errors['AeEmailSFDC']}</span>
  </FormColumn>
</FormRow>


<FormRow>
  <FormColumn half>
    <Label required>Salesforce Region</Label>
    <select value={this.state.salesforceRegion} name="salesforceRegion" onChange={this.handleInputChange} className="w-select" required="required">
    <option disabled value="" selected>Choose one</option>
    {this.optionsFromList(salesforceRegion, 'salesforceRegion')}
    </select>
  </FormColumn>

  <FormColumn half>
    <Label required>Salesforce Segment</Label>
    <select value={this.state.salesforceSegment} name="salesforceSegment" onChange={this.handleInputChange} className="w-select" required="required">
    <option disabled value="" selected>Choose one</option>
    {this.optionsFromList(salesforceSegment, 'salesforceSegment')}
    </select>
  </FormColumn>
</FormRow>

              <FormSectionTitle>Customer Company & Contact Information</FormSectionTitle>
              <FormRow>
                <FormColumn half>
                  <Label required>Customer First Name</Label>
                  <input onChange={this.handleInputChange} value={this.state.firstName} type='text' className="w-input" name='firstName' placeholder='Customer First Name'  required />
                  <span className="danger">{this.state.errors['firstName']}</span>
                </FormColumn>
                <FormColumn half>
                  <Label required>Customer Last Name</Label>
                  <input onChange={this.handleInputChange} value={this.state.lastName} type='text' className="w-input" name='lastName' placeholder='Customer Last Name'  required />
                </FormColumn>
                <FormColumn half>
                  <Label required>Customer Title</Label>
                    <input onChange={this.handleInputChange} value={this.state.title} type='text' className="w-input" name='title' placeholder='Customer Title' required="required" />
                </FormColumn>
              </FormRow>

              <FormRow>
              <FormColumn half>
                  <Label required>Customer Email Address </Label>
                    <input onChange={this.handleInputChange} onKeyUp={this.validateForm} value={this.state.email} type='text' className="w-input" name='email' placeholder='Customer Email Address' required="required" />
                    <span className="danger">{this.state.errors['email']}</span>
                </FormColumn>

                   <FormColumn half>
                  <Label required>Customer City</Label>
                    <input onChange={this.handleInputChange} value={this.state.city} type='text' className="w-input" name='city' placeholder='Customer City' required="required" />
                </FormColumn>


                
              </FormRow>

              <FormRow>
                <FormColumn half>
                  <Label required>Customer Country</Label>
                  <select required="required" value={this.state.country} name="country" onChange={this.handleInputChange} className="w-select">
                  <option disabled value="" selected>Choose one</option>
                  {this.loadCountries()}
                </select>
                </FormColumn>
                  {this.loadStates()}
              </FormRow>

              <FormRow>
                <FormColumn half>
                  <Label required>Customer Website</Label>
                  <input onChange={this.handleInputChange} value={this.state.website} type='text' className="w-input" name='website' placeholder='www.example.com' required="required" />
                </FormColumn>
            
                <FormColumn half>
                  <Label required>Customer Company Name</Label>
                  <input onChange={this.handleInputChange} value={this.state.companyName} type='text' className="w-input" name='companyName' placeholder='Customer Company Name' required />
                </FormColumn>
              </FormRow>

                

              <FormRow>
                <FormColumn half>
                  <Label required>Phone Number</Label>
                  <input onChange={this.handleInputChange} value={this.state.phoneNumber} type='text' className="w-input" name='phoneNumber' placeholder='(888) 777 9999' required="required" />
                </FormColumn>

                <FormColumn half>
                  <Label required>Number of Employees</Label>
                  <input onChange={this.handleInputChange} value={this.state.numberOfEmployees} type='number' className="w-input" name='numberOfEmployees' placeholder='# of Employees' required="required" min="1" />
                </FormColumn>
              </FormRow>

              <FormSectionTitle>Service of Interest</FormSectionTitle>
                <p style={{textAlign: 'center', marginTop: '20px'}}>Please select one or more services:</p>
              <FormRow>

                  {this.checkboxesfromList(serviceInterest, 'serviceInterest')}

              </FormRow>

              <FormRow>
                <FormColumn half>
                  <Label required>Total potential Users</Label>
                  <select value={this.state.potentialUsers} name="potentialUsers" onChange={this.handleInputChange} className="w-select" required="required">
                  <option disabled value="" selected>Choose one</option>
                  {this.optionsFromList(potentialUsers, 'potentialUsers')}

                  </select>
                </FormColumn>

                <FormColumn half>
                  <Label required>Purchasing Timeframe</Label>
                  <select required value={this.state.purchasingTimeframe} name="purchasingTimeframe" onChange={this.handleInputChange} className="w-select" required="required">
                  <option value="" disabled selected>Choose one</option>
                  {this.optionsFromList(purchasingTimeFrame, 'purchasingTimeframe')}
                  </select>
                </FormColumn>
              </FormRow>

              <FormRow>
                <FormColumn half>
                  <Label required>Potential Sales Value</Label>
                  <select value={this.state.potentialSalesValue} name="potentialSalesValue" onChange={this.handleInputChange} className="w-select" required="required">
                  <option disabled value="" selected>Choose one</option>
                  {this.optionsFromList(potentialSalesValue, 'potentialSalesValue')}
                  </select>
                </FormColumn>
              </FormRow>

                <FormSectionTitle>Discovery & Scoping</FormSectionTitle>

                <FormRow>
                  <FormColumn half>
                    <Label required>Goals</Label>
                    <textarea onChange={this.handleInputChange} value={this.state.goals} className="w-input" name='goals' placeholder='Goals' required="required" />
                  </FormColumn>

                  <FormColumn half>
                    <Label required>Pains</Label>
                    <textarea onChange={this.handleInputChange} value={this.state.pains} className="w-input" name='pains' placeholder='Pains' required="required" />
                  </FormColumn>
                </FormRow>

                <FormRow>
                <FormColumn half>
                    <Label required>Existing Salesforce Licenses</Label>
                    <textarea onChange={this.handleInputChange} value={this.state.existingLicences} className="w-input" name='existingLicences' placeholder='Sales Cloud EE, Marketing Cloud Pro' required="required" />
                  </FormColumn>
                  <FormColumn half>
                    <Label required>What licenses are you selling / what licenses need to be implemented?</Label>
                    <textarea onChange={this.handleInputChange} value={this.state.sellingLicenses} className="w-input" name='sellingLicenses' placeholder='Sales Cloud EE, Marketing Cloud Pro' required="required" />
                  </FormColumn>
                </FormRow>

                <FormRow>
                <FormColumn half>
                    <Label required>Key features to activate for this project?</Label>
                    <textarea onChange={this.handleInputChange} value={this.state.keyFeatures} className="w-input" name='keyFeatures' placeholder='Journeys, Reports' required="required" />
                  </FormColumn>
                  <FormColumn half>
                    <Label required>What systems are in the customer’s Tech Stack?</Label>
                    <textarea onChange={this.handleInputChange} value={this.state.techStack} className="w-input" name='techStack' placeholder='Tech stack description' required="required" />
                  </FormColumn>
                </FormRow>

                <FormRow>
                <FormColumn half>
                    <Label>Does this project require any Integrations? If yes, please name the system.</Label>
                    <textarea onChange={this.handleInputChange} value={this.state.integrations} className="w-input" name='integrations' placeholder='Integrations required, if any.'  />
                  </FormColumn>
                  <FormColumn half>
                    <Label>Please provide options for a customer scoping call.</Label>
                    <textarea onChange={this.handleInputChange} value={this.state.scopingDetails} className="w-input" name='scopingDetails' placeholder='Enter best date/time or week for a scoping call'  />
                  </FormColumn>
                </FormRow>

                
                <FormRow>
                <FormColumn half>
                    <Label>Desired project start date.</Label>
                    <input onChange={this.handleInputChange} value={this.state.desiredStartDate} className="w-input" name='desiredStartDate' type='date'   />
                  </FormColumn>
                  <FormColumn half>
                    <Label>Desired go-live date.</Label>
                    <input onChange={this.handleInputChange} value={this.state.desiredGoLiveDate} className="w-input" name='desiredGoLiveDate' type='date'  />
                  </FormColumn>
                </FormRow>

                <FormSectionTitle>Next Steps</FormSectionTitle>

                <FormRow>
                  <FormColumn half>
                    <Label required>Next Steps</Label>
                    <textarea onChange={this.handleInputChange} value={this.state.nextSteps} className="w-input" name='nextSteps' placeholder='Next Steps' required="required" />
                  </FormColumn>

                  <FormColumn half>
                    <Label required>Should we reach out directly or will you introduce us?</Label>
                    <input type='radio' name='reachOut' value="reach Out Directly" /> <span>Reach out directly</span> 
                    <input type='radio' name='reachOut' value="I Will Introduce You" /> <span>I will introduce you</span> 
                  </FormColumn>
                </FormRow>

               
              <div className="required-disclaimer">* indicates required fields</div>
              <div className="required-disclaimer">By submitting this form, you are confirming you have read and agree to our <a target="_blank" href="https://www.bubblebox.cloud/pages/privacy-policy">Terms and Privacy Statement.</a></div>
              <div className="form-row submit">
                <input type='hidden' name="serviceOfInterestType" value={this.state.serviceOfInterestType} />
                <button type="submit" className="request-button w-button">Submit Request</button></div>
            </form>


          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Form.js